import type { Resource } from '../../';
export const country_countries_PH: Resource = {"default":"Philippines"};
